module.exports = __webpack_public_path__ + "static/media/driedginger.2e90aca3.png";